import React from 'react'
import styled from 'styled-components'

import { Helmet } from 'react-helmet'
import { NavLink as RouterNavLink, NavLinkProps } from 'react-router-dom'
import {
  Breadcrumbs as MuiBreadcrumbs,
  Divider as MuiDivider,
  Grid,
  Link,
  Typography,
} from '@material-ui/core'
import { spacing } from '@material-ui/system'

import {
  useQueryPaginator,
  AppointmentField,
  LinkedField,
  PaginatedTable,
  ValueField,
  StatusField,
} from 'src/components/Table'

import { skuit } from 'src/services/skuit'

const NavLink = React.forwardRef((props: NavLinkProps, ref: React.Ref<HTMLAnchorElement>) => (
  <RouterNavLink innerRef={ref} {...props} />
))
NavLink.displayName = 'NavLink'

const Divider = styled(MuiDivider)(spacing)

const Breadcrumbs = styled(MuiBreadcrumbs)(spacing)

export const TruckloadListPage = () => {
  const paginator = useQueryPaginator('truckload-list', skuit.client.freight.truckloads.list)

  const exportFields = [
    "bill_of_lading_number",
    "carrier_guid",
    "carrier_name",
    "facility_address",
    "facility_guid",
    "facility_name",
    "guid",
    "loaded_on",
    "name",
    "shipped_on",
    "status",
    "tracking_number",
    "trailer_number",
  ]

  return (
    <>
      <Helmet title="Truckloads" />
      <Grid justify="space-between" container spacing={10}>
        <Grid item>
          <Typography variant="h3" gutterBottom display="inline">
            Truckloads
          </Typography>

          <Breadcrumbs aria-label="Breadcrumb" mt={2}>
            <Link component={NavLink} exact to="/">
              Dashboard
            </Link>
            <Typography>Truckloads</Typography>
          </Breadcrumbs>
        </Grid>
      </Grid>

      <Divider my={6} />

      <Grid container spacing={6}>
        <Grid item xs={12}>
          <PaginatedTable
            title="Truckloads"
            fields={[
              { id: 'trackingNumber', label: 'Tracking Number', renderer: LinkedField(ValueField) },
              { id: 'billOfLadingNumber', label: 'BoL', renderer: ValueField },
              { id: 'trailerNumber', label: 'Trailer Number', renderer: ValueField },
              { id: 'facility.name', label: 'Facility', renderer: ValueField },
              { id: 'carrier.name', label: 'Carrier', renderer: ValueField },
              { id: 'status', label: 'Status', renderer: StatusField },
              { id: 'appointment', label: 'Appointment', renderer: AppointmentField },
            ]}
            paginator={paginator}
            exportConfig={{
              exportFields: exportFields,
              exportAPI: skuit.client.truckloads.export,
            }}
          />
        </Grid>
      </Grid>
    </>
  )
}
